module.exports = __webpack_public_path__ + "img/3.955dc76d.png";